<template>
  <div class="pa-4">
    <h1>aggrid api</h1>
    <p>
      <v-btn @click="selectData">
        选中数据
      </v-btn>
    </p>
    <ag-grid-vue
      :grid-options="gridOptions"
      style="height: 65vh;"
      class="ag-theme-alpine"
      :column-defs="columnDefs"
      :row-data="rowData"
      @selection-changed="onSelectionChanged"
    />
    selectedRows: {{ selectedRows }}
  </div>
</template>
<script>
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridVue } from "ag-grid-vue";

LicenseManager.setLicenseKey('CompanyName=Suzhou ruhlamat Smart Technologies Co., Ltd.,LicensedApplication=Infinity,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=30,AssetReference=AG-030422,SupportServicesEnd=30_August_2023_[v2]_MTY5MzM1MDAwMDAwMA==28423dd515d527503fc5a257dc86a8ac');

export default {
  name: "Aggrid",
  components: {
    AgGridVue,
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      gridOptions: {
        rowHeight: 35, // 默认行高
        rowSelection: 'multiple', // 默认多选
      },
      gridApi: {},
      gridColumnApi: {},
      selectedRows: [],
    };
  },
  beforeMount() {
    this.columnDefs = [
      { field: "make", checkboxSelection: true, headerCheckboxSelection: true,},
      { field: "model" },
      { field: "price" },
      { field: "id" },
    ];

    this.rowData = [
      { id: 233, make: "Toyota", model: "Celica", price: 35000 },
      { id: 234, make: "Ford", model: "Mondeo", price: 32000 },
      { id: 235, make: "Porsche", model: "Boxster", price: 72000 },
      { id: 236, make: "Porsche", model: "Boxster", price: 72000 },
      { id: 237, make: "Porsche", model: "Boxster", price: 72000 },
    ];
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;

    this.selectRowById(1);
  },

  methods: {

    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      // this.$emit('input', selectedRows);
    },

    selectRowById(rowId) {
      const rowNode = this.gridApi.getRowNode(rowId);
      if (rowNode) {
        rowNode.setSelected(true);
      } else {
        console.warn(`Row with id ${rowId} not found.`);
      }
    },
    selectData() {
      const ids = [235, 236];

      console.log(this.gridApi, 'gridApi', ids);
      console.log(this.gridColumnApi, 'gridColumnApi');

      // 选中data
      const rowids = this.rowData
        .map((data, rowIndex) => ({
          ...data,
          rowIndex,
        }))
        .filter(a => ids.findIndex(id => a.id === id) > -1)
        .map(a => a.rowIndex);

      console.log(rowids, 'rowids');

      rowids.forEach((id) => {
        this.selectRowById(id);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";

</style>